import React from "react";
export function ContainsChildrenOfType(children, type) {
    return GetChildrenOfType(children, type).length > 0;
}
export function GetChildrenOfType(children, type) {
    var result = [];
    React.Children.forEach(children, function (child) {
        if (React.isValidElement(child)) {
            // if child is fragment, check its children
            if (child.type === React.Fragment) {
                result = result.concat(GetChildrenOfType(child.props.children, type));
            }
            if (child.type === type) {
                result.push(child);
            }
        }
    });
    return result;
}
